export enum TaskStatus {
  Idle = 'IDLE',
  Executing = 'EXECUTING',
  Completed = 'COMPLETED',
  Error = 'ERROR',
}
